export default __webpack_public_path__ + "static/media/gallery - story - fountain (1)_01.16330e8a.jpg";